import React from "react";
import style from "./css/ImageSlider.module.css";
// swiper install
import { Navigation, Pagination,Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
// import slider image
import slider1 from "./assests/s-img-1.jpeg";
import slider2 from "./assests/s-img-2.jpeg";
import slider3 from "./assests/s-img-3.jpeg";
import slider4 from "./assests/s-img-4.jpeg";

function ImageSlider() {
  const notice = [
    {
      id: 1,
      notice: "New Batch for HTML Starting from 29-01-2024 at 04PM"
    },
    {
      id: 2,
      notice: "New Batch for Digital Marketing Starting from 22-01-2024 at 11AM"
    },
    {
      id: 3,
      notice: "New Batch for Advance EXCEL Starting from 24-01-2024 at 02PM"
    },
    {
      id: 4,
      notice: "New Batch for DCA | ADCA | DFA Starting from 19-01-2024 at 08 AM"
    },
    {
      id: 5,
      notice: "New Batch for Web Development Starting from 19-02-2024 at 03 PM"
    }
  ];
  return (
    <>
      <div className="container-fluid bg-primary">
        <div className="row">
          <div className="col-lg-9">
            <Swiper
              // install Swiper modules
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={50}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              navigation
              pagination={{ clickable: true }}

            >
              <SwiperSlide><img src={slider1} alt="slider img" className={style.pic} /></SwiperSlide>
              <SwiperSlide><img src={slider2} alt="slider img" className={style.pic} /></SwiperSlide>
              <SwiperSlide><img src={slider3} alt="slider img" className={style.pic} /></SwiperSlide>
              <SwiperSlide><img src={slider4} alt="slider img" className={style.pic} /></SwiperSlide>
            </Swiper>
          </div>
          <div className="col-lg-3 bg-warning text-primary">
            <h4 className="text-center text-danger p-2">Important Notice</h4>
            <div className={style.notice}>
              <div className={style.animate}>
                <ul>
                  {notice.map((e) => (
                    <li key={e.id}>{e.notice}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImageSlider;
